import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  MicrosoftTenantIdAvailabilityResponse,
  GoogleWorkspaceDomainAvailabilityResponse,
  DomainAvailabilityResponse,
  MicrosoftTenantIdValidationParams,
  RegistroBrDomainAvailabilityResponse,
  DomainOwnershipValidationResponse,
} from '../models/validation.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  private readonly API_URL = '/validation';
  private apiService = inject(ApiService);


  checkMicrosoftTenantIdAvailability(
    params: MicrosoftTenantIdValidationParams
  ): Observable<MicrosoftTenantIdAvailabilityResponse> {
    const url = `${this.API_URL}/microsoft-tenant-id/availability/${params.productUuid}/${params.isVariation}/${params.userUuid}/${params.tenantId}/${params.tenantPreference}`;
    return this.apiService.get<MicrosoftTenantIdAvailabilityResponse>(url);
  }

  checkGoogleWorkspaceDomainAvailability(
    domain: string
  ): Observable<GoogleWorkspaceDomainAvailabilityResponse> {
    const url = `${this.API_URL}/google-ws-domain/availability/${domain}`;
    return this.apiService.get<GoogleWorkspaceDomainAvailabilityResponse>(url);
  }

  checkDomainAvailability(
    domain: string
  ): Observable<DomainAvailabilityResponse> {
    const url = `${this.API_URL}/domain/availability/${domain}`;
    return this.apiService.get<DomainAvailabilityResponse>(url);
  }

  checkRegistroBrDomainAvailability(
    domain: string
  ): Observable<RegistroBrDomainAvailabilityResponse> {
    const url = `${this.API_URL}/registrobr/domain/availability/${encodeURIComponent(domain)}`;
    return this.apiService.get<RegistroBrDomainAvailabilityResponse>(url);
  }

  validateDomainOwnership(
    domain: string,
    valueToValidate: string
  ): Observable<DomainOwnershipValidationResponse> {
    const url = `${this.API_URL}/domain/ownership/validate/${encodeURIComponent(domain)}/${encodeURIComponent(valueToValidate)}`;
    return this.apiService.get<DomainOwnershipValidationResponse>(url);
  }
}
